<nb-actions size="small" id="nbNotificationsIcon">
  <nb-action class="control-item" style="background-color: #1a3756;" icon="email-outline" [nbPopover]="notificationListComponent" nbPopoverTrigger="click"
    nbPopoverPlacement="bottom">
  </nb-action>
</nb-actions>